import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
import './PageHeader.scss';

const PageHeader = ({
    title,
    subtitle,
    breadcrumbs = [],
    backgroundVariant = 'default' // 'default', 'gradient', 'pattern'
}) => {
    return (
        <section className={`jk-page-header jk-page-header--${backgroundVariant}`}>
            <div className="jk-page-header__bg">
                <div className="jk-page-header__bg-gradient"></div>
                <div className="jk-page-header__bg-pattern"></div>
                <div className="jk-page-header__bg-glow jk-page-header__bg-glow--1"></div>
                <div className="jk-page-header__bg-glow jk-page-header__bg-glow--2"></div>
            </div>

            <div className="jk-page-header__container">
                {/* Breadcrumbs */}
                <nav className="jk-page-header__breadcrumbs" aria-label="Breadcrumb">
                    <ol className="jk-page-header__breadcrumb-list">
                        <li className="jk-page-header__breadcrumb-item">
                            <Link to="/" className="jk-page-header__breadcrumb-link">
                                <Home size={16} />
                                <span>Home</span>
                            </Link>
                        </li>
                        {breadcrumbs.map((crumb, index) => (
                            <li key={index} className="jk-page-header__breadcrumb-item">
                                <ChevronRight size={16} className="jk-page-header__breadcrumb-separator" />
                                {crumb.path ? (
                                    <Link to={crumb.path} className="jk-page-header__breadcrumb-link">
                                        {crumb.label}
                                    </Link>
                                ) : (
                                    <span className="jk-page-header__breadcrumb-current">{crumb.label}</span>
                                )}
                            </li>
                        ))}
                    </ol>
                </nav>

                {/* Title */}
                <h1 className="jk-page-header__title">{title}</h1>

                {/* Subtitle */}
                {subtitle && (
                    <p className="jk-page-header__subtitle">{subtitle}</p>
                )}
            </div>
        </section>
    );
};

export default PageHeader;
